import { QueryParameterSchema } from '../../context/QueryParameterContext';

export const archivedFilter: QueryParameterSchema<'archived'> = {
  getDefaultValue: () => undefined,
  getValue: ({ parameters }) => parameters.archived,

  fromUrlSearchParams: ({ urlSearchParams }) => ({
    archived: urlSearchParams.get('filter[archived]') || undefined,
  }),
  toUrlSearchParams: ({ value }) => {
    if (!value) return {};
    return { 'filter[archived]': value };
  },
  toSearchQuery: ({ value }) => {
    if (!value) return {};
    return { 'filter[archived]': value === 'true' };
  },
  sanitize: ({ value }) => {
    if (value === 'true' || value === 'false') return { archived: value };
    return { archived: undefined };
  },
  getSummaryItems: ({ value }) => {
    if (value === 'true') {
      return [{ key: 'archived', label: 'Archived', filterKey: 'archived', value: 'Yes' }];
    }
    return [];
  },
};
